<template lang="pug">
  img(:src="source" :alt="alt" :loading="loading" :decoding="decoding")
</template>

<script setup lang="ts">
import { computed } from 'vue'

const localImages = import.meta.glob<string>('../../assets/images/*', {
  eager: true,
  query: '?url',
  import: 'default',
})

const props = withDefaults(
  defineProps<{
    path?: string
    alt?: string
    external?: boolean
    loading?: 'eager' | 'lazy'
    decoding?: 'sync' | 'async' | 'auto'
  }>(),
  {
    path: '',
    alt: '',
    external: false,
    loading: 'lazy',
    decoding: 'async',
  },
)

const source = computed(() => {
  if (!props.path) return ''
  if (/^https?:\/\//i.test(props.path)) return props.path

  if (props.external) {
    const origin = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '')
    return `${origin}/${props.path.replace(/^\//, '')}`
  }

  return localImages[`../../assets/images/${props.path}`] ?? ''
})
</script>
